import React, { useEffect, useState } from 'react';
import Loaders from '../Loaders';
import HeaderTop from '../HeaderTop';
import Menus from '../Menus';
import Footers from '../Footers';
import '../../../libs/css/bootstrap.min3.3.7.css';
import '../../../libs/css/sweetalert2.min.css';
import { API_ROUTES } from '../../../utils/constants';
import SubCountReportFilter from './SubCountReportFilter';
import SubCountReportTable from './SubCountReportTable';
import { format } from 'date-fns';

export default function SubCountReport(props) {
    const { objectToFormData, isAuthExpired } = props;

    useEffect(() => { document.title = 'Subscriber Count Report | Forthsoft'; }, []);

    const [isLoading, setIsLoading] = useState(false);
    const [isFade, setIsFade] = useState(false);
    const [dataList, setDataList] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [reportType, setReportType] = useState('');

    const userData = JSON.parse(localStorage.getItem('userDataFs'));

    const getData = async (filters) => {
        const { fro, to, network_id, type, serviceId } = filters;

        const dataString = { fro, to, network_id, type };
        if (serviceId) dataString.serviceId = serviceId;

        setIsLoading(true);
        setIsFade(true);
        setReportType(type);

        try {
            const response = await fetch(API_ROUTES.SUBSCRIBER_COUNTS, {
                method: 'POST',
                body: objectToFormData(dataString),
                headers: { token: userData?.responseDetails?.token },
            });
            const responseJSON = await response.json();
            isAuthExpired(responseJSON);

            if (responseJSON.status.toString() === '200') {
                const list = responseJSON.data;
                setDataList(list);
                const total = list.reduce((sum, item) => sum + parseFloat(item.count), 0);
                setTotalCount(total);
            } else {
                setDataList([]);
                setTotalCount(0);
            }
        } catch (error) {
            console.log('Error getting subscriber count data:', error);
            setDataList([]);
            setTotalCount(0);
        } finally {
            setIsLoading(false);
            setIsFade(false);
        }
    };

    const exportToCSV = () => {
        if (dataList.length === 0) {
            alert('No data available to export');
            return;
        }

        let csvContent = 'data:text/csv;charset=utf-8,';
        csvContent += 'Period,Count\n';
        dataList.forEach(row => {
            csvContent += `"${row.period}",${row.count}\n`;
        });

        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', `sub_count_${reportType}_${format(new Date(), 'yyyy-MM-dd')}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            <Loaders />

            <div className="flapt-page-wrapper mainContent">
                <Menus />

                <div className="flapt-page-content">
                    <HeaderTop />

                    <div className="main-content introduction-farm mt--20">
                        <div className="content-wraper-area">
                            <div className="dashboard-area">
                                <div className="container-fluid mb-90">
                                    <div className="row g-4">
                                        <div className="col-lg-12 pl-xs-0 pr-xs-0">
                                            <div className="card-header mb--20 mb-xs-10">
                                                <h2>Subscriber Count Report</h2>
                                            </div>

                                            <div className="App">
                                                <SubCountReportFilter
                                                    onSubmit={getData}
                                                    isLoading={isLoading}
                                                    objectToFormData={objectToFormData}
                                                    isAuthExpired={isAuthExpired}
                                                />

                                                <SubCountReportTable
                                                    dataList={dataList}
                                                    isLoading={isLoading}
                                                    isFade={isFade}
                                                    totalCount={totalCount}
                                                    reportType={reportType}
                                                    onExportCSV={exportToCSV}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Footers />
                    </div>
                </div>
            </div>
        </>
    );
}
